<template>
  <Tooltip>
    <template slot="element">
      <Badge color="warning">
        {{ $t('old') }}
      </Badge>
    </template>
    <span>
      {{ $t('This offer was submitted before last changes in the tender') }}
    </span>
  </Tooltip>
</template>

<script>
  import Tooltip from '@/components/ui/InfoTooltip';
  import Badge from '@/components/ui/Badge';

  export default {
    name: 'TenderOfferVersionOldBadge',
    components: { Tooltip, Badge },
  };
</script>
